import React from "react";

import { updateConfig } from "../../config/config";
import {
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { ChryslerLogo } from "./ChryslerLogo";
import "./theme.css";

updateConfig({
  HeaderAddons: () => (
    <div className="flex-1 hidden lg:block">
      <img
        alt="Chrysler Group Logos"
        className="h-8 mx-auto block"
        src="/static/img/chrysler_v2/header-logos.png"
      />
    </div>
  ),
  LandingPageContent: () => <></>,
  Logo: () => <ChryslerLogo className="h-6 md:h-9" />,
  brandName: "Chrysler",
  googleMapsMarkerSrc: "/static/img/chrysler_v2/google_maps_marker.svg",
  landingPageImage: {
    [productTypeAccessory]: "/static/blocks/landing-accessories.png",
    [productTypePackage]: "/static/blocks/landing-packages.png",
    [productTypeTire]: "/static/blocks/landing-tires.png",
    [productTypeWheel]: "/static/blocks/landing-wheels.png",
  },
  productHeroBackground: null,
  themeClass: "chrysler-theme",
});
